import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import _get from "lodash/get";
import _isFunction from "lodash/isFunction";
import _isNil from "lodash/isNil";
import _isEmpty from "lodash/isEmpty";
import _isEqual from "lodash/isEqual";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.is-array.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useState, useEffect, useImperativeHandle, useCallback } from 'react';
import { useDeepEffect } from '../../hooks';
import inputValidation from '../inputValidation';
import { outputValue, prepareValue, areEquals as _areEquals, DEFAULT_DISPLAY_KEY, DEFAULT_UNIQUE_KEY, prepareOptions } from './utils';
export var useDropDown = function useDropDown(_ref) {
  var initValue = _ref.value,
      _ref$options = _ref.options,
      initOptions = _ref$options === void 0 ? [] : _ref$options,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      onError = _ref.onError,
      _ref$open = _ref.open,
      open = _ref$open === void 0 ? false : _ref$open,
      _ref$multiSelect = _ref.multiSelect,
      multiSelect = _ref$multiSelect === void 0 ? false : _ref$multiSelect,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      mapValue = _ref.mapValue,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      validate = _ref.validate,
      _ref$isTouched = _ref.isTouched,
      isTouchedInit = _ref$isTouched === void 0 ? false : _ref$isTouched,
      _ref$displayKey = _ref.displayKey,
      displayKey = _ref$displayKey === void 0 ? DEFAULT_DISPLAY_KEY : _ref$displayKey,
      _ref$uniqueKey = _ref.uniqueKey,
      uniqueKey = _ref$uniqueKey === void 0 ? DEFAULT_UNIQUE_KEY : _ref$uniqueKey,
      renderSelected = _ref.renderSelected,
      placeholder = _ref.placeholder,
      label = _ref.label,
      dropdownRef = _ref.dropdownRef;
  var options = prepareOptions(initOptions, displayKey);
  var selectedValue = prepareValue(initValue, options, multiSelect, displayKey, uniqueKey);

  var _useState = useState(selectedValue),
      _useState2 = _slicedToArray(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  var _useState3 = useState(open),
      _useState4 = _slicedToArray(_useState3, 2),
      isOpen = _useState4[0],
      setIsOpen = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      error = _useState6[0],
      setError = _useState6[1];

  var _useState7 = useState(isTouchedInit),
      _useState8 = _slicedToArray(_useState7, 2),
      isTouched = _useState8[0],
      setIsTouched = _useState8[1];

  var _useState9 = useState(-1),
      _useState10 = _slicedToArray(_useState9, 2),
      focusedIndex = _useState10[0],
      setFocusedIndex = _useState10[1];

  var isDisabled = !(options !== null && options !== void 0 && options.length) || disabled; // Those two references need to be states instead of refs because react-popper does not work with refs

  var _useState11 = useState(),
      _useState12 = _slicedToArray(_useState11, 2),
      selectRef = _useState12[0],
      setSelectRef = _useState12[1];

  var _useState13 = useState(),
      _useState14 = _slicedToArray(_useState13, 2),
      optionsListRef = _useState14[0],
      setOptionsListRef = _useState14[1];

  useImperativeHandle(dropdownRef, function () {
    return {
      changeValue: function changeValue(newValue) {
        return handleSelect(newValue);
      },
      clear: function clear() {
        return handleSelect(null);
      },
      value: selected,
      changeIsTouched: setIsTouched
    };
  });
  useEffect(function () {
    setIsTouched(isTouchedInit);
  }, [isTouchedInit]);
  useEffect(function () {
    isTouched && checkForError(selected);
  }, [isTouched]); // When the options are async and we have value some id, we should have this effect to update selected with matched option

  useDeepEffect(function () {
    setSelected(selectedValue);
  }, [options]);
  useDeepEffect(function () {
    !_areEquals(selected, selectedValue, displayKey, uniqueKey) && setSelected(selectedValue);
  }, [initValue, options]); // Reset focused index when dropdown opens/closes

  useEffect(function () {
    if (isOpen) {
      // When opening, try to focus the currently selected option
      if (!multiSelect && selected) {
        var idx = options.findIndex(function (opt) {
          return !opt.groupLabel && _areEquals(opt, selected, displayKey, uniqueKey);
        });
        setFocusedIndex(idx >= 0 ? idx : 0);
      } else setFocusedIndex(0);
    } else setFocusedIndex(-1);
  }, [isOpen]); // eslint-disable-line react-hooks/exhaustive-deps

  var handleToggle = function handleToggle() {
    return !isDisabled && setIsOpen(function (prev) {
      return !prev;
    });
  };

  var getSelectableOptions = useCallback(function () {
    return options.filter(function (opt) {
      return !opt.groupLabel;
    });
  }, [options]);

  var handleKeyDown = function handleKeyDown(e) {
    var key = e.key; // Open dropdown on Enter, Space, or Arrow Down when closed

    if (!isOpen) {
      if (key === 'Enter' || key === ' ' || key === 'ArrowDown' || key === 'ArrowUp') {
        e.preventDefault();
        setIsOpen(true);
        return;
      }

      return;
    } // Close on Escape or Tab


    if (key === 'Escape') {
      e.preventDefault();
      setIsOpen(false);
      selectRef === null || selectRef === void 0 ? void 0 : selectRef.focus();
      return;
    }

    if (key === 'Tab') {
      setIsOpen(false);
      !isTouched && setIsTouched(true);
      checkForError(selected);
      return;
    }

    var selectableOptions = getSelectableOptions();
    var selectableCount = selectableOptions.length;

    if (key === 'ArrowDown') {
      e.preventDefault();
      setFocusedIndex(function (prev) {
        // Find next non-group option
        var next = prev + 1;

        while (next < options.length && (_options$next = options[next]) !== null && _options$next !== void 0 && _options$next.groupLabel) {
          var _options$next;

          next++;
        }

        return next >= options.length ? prev : next;
      });
      return;
    }

    if (key === 'ArrowUp') {
      e.preventDefault();
      setFocusedIndex(function (prev) {
        var next = prev - 1;

        while (next >= 0 && (_options$next2 = options[next]) !== null && _options$next2 !== void 0 && _options$next2.groupLabel) {
          var _options$next2;

          next--;
        }

        return next < 0 ? prev : next;
      });
      return;
    }

    if (key === 'Enter' || key === ' ') {
      var _options$focusedIndex;

      e.preventDefault();
      if (focusedIndex >= 0 && focusedIndex < options.length && !((_options$focusedIndex = options[focusedIndex]) !== null && _options$focusedIndex !== void 0 && _options$focusedIndex.groupLabel)) handleSelect(options[focusedIndex]);
      return;
    } // Type-ahead: jump to first option starting with the typed character


    if (key.length === 1 && !e.ctrlKey && !e.metaKey) {
      var _char = key.toLowerCase();

      var startIdx = focusedIndex + 1;
      var matchIndex = options.findIndex(function (opt, idx) {
        return idx >= startIdx && !opt.groupLabel && _get(opt, displayKey, '').toLowerCase().startsWith(_char);
      });
      if (matchIndex >= 0) setFocusedIndex(matchIndex);else {
        // Wrap around from beginning
        var wrapIndex = options.findIndex(function (opt) {
          return !opt.groupLabel && _get(opt, displayKey, '').toLowerCase().startsWith(_char);
        });
        if (wrapIndex >= 0) setFocusedIndex(wrapIndex);
      }
    }
  };

  var handleBlur = function handleBlur(_ref2) {
    var currentTarget = _ref2.currentTarget,
        relatedTarget = _ref2.relatedTarget;

    if (!(currentTarget !== null && currentTarget !== void 0 && currentTarget.contains(relatedTarget)) && !(optionsListRef !== null && optionsListRef !== void 0 && optionsListRef.contains(relatedTarget)) && isOpen && !isDisabled) {
      setIsOpen(false);
      !isTouched && setIsTouched(true);
      checkForError(selected);
      _isFunction(onBlur) && onBlur(hookProperties);
    }
  };

  var handleSelect = function handleSelect(newValue) {
    setIsTouched(true);
    checkForError(newValue);

    if (multiSelect) {
      if (_isNil(newValue)) return changeValue([]);
      var selectedUnique = selected === null || selected === void 0 ? void 0 : selected.filter(function (el) {
        return !_isNil(el);
      });
      var valueIndex = selectedUnique.findIndex(function (e) {
        return _areEquals(e, newValue, displayKey, uniqueKey);
      });
      if (valueIndex === -1) return changeValue([].concat(_toConsumableArray(selectedUnique), [newValue]));
      selectedUnique.splice(valueIndex, 1);
      return changeValue(selectedUnique);
    }

    setIsOpen(false);
    return changeValue(newValue);
  };

  var changeValue = function changeValue(newValue) {
    if (_isEqual(newValue, selected)) return;
    setSelected(newValue);
    _isFunction(onChange) && onChange(outputValue(newValue, displayKey, mapValue));
    isOpen && (selectRef === null || selectRef === void 0 ? void 0 : selectRef.focus());
  };

  var checkForError = function checkForError(newValue) {
    var newError = null; // If validate function is provided check for error

    if (_isFunction(validate)) newError = validate(newValue);else if (required) {
      newError = multiSelect ? _isEmpty(newValue) && {
        msg: 'Required field'
      } : inputValidation('required')(newValue && newValue[uniqueKey]);
    }
    _isFunction(onError) && onError(newError);
    isTouched && setError(newError);
  };

  var defaultPlaceholder = placeholder !== null && placeholder !== void 0 ? placeholder : label && "".concat(label, "...");
  var renderedSelection = _isFunction(renderSelected) ? renderSelected(selected) : null;

  var getOptionValue = function getOptionValue(val) {
    var _val$render, _get2;

    if (!val) return defaultPlaceholder;
    if (val !== null && val !== void 0 && val.render) return (_val$render = val.render(val)) !== null && _val$render !== void 0 ? _val$render : defaultPlaceholder;
    return (_get2 = _get(val, displayKey)) !== null && _get2 !== void 0 ? _get2 : defaultPlaceholder;
  };

  var displayValue = renderedSelection !== null && renderedSelection !== void 0 ? renderedSelection : multiSelect ? defaultPlaceholder : getOptionValue(selected);
  var hookProperties = {
    isOpen: isOpen,
    setIsOpen: setIsOpen,
    isTouched: isTouched,
    setIsTouched: setIsTouched,
    isDisabled: isDisabled,
    selected: selected,
    options: options,
    error: error,
    focusedIndex: focusedIndex,
    handleToggle: handleToggle,
    handleKeyDown: handleKeyDown,
    handleBlur: handleBlur,
    handleSelect: handleSelect,
    selectRef: selectRef,
    setSelectRef: setSelectRef,
    optionsListRef: optionsListRef,
    setOptionsListRef: setOptionsListRef,
    displayValue: displayValue,
    areEquals: function areEquals(val) {
      return _areEquals(selected, val, displayKey, uniqueKey);
    }
  };
  return hookProperties;
};